import { uniqBy } from 'lodash';

const getOrderLineDiagnosisPointer = ({ orderLine, diagnosis, value, index, type = 'alphabetical' }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (orderLine && index !== undefined
      && orderLine[index] && orderLine[index].Diagnosis && diagnosis) {
    const uniqByKey = orderLine[index].Diagnosis
      && orderLine[index].Diagnosis[0]
      && orderLine[index].Diagnosis[0].ID ? 'ID' : 'value';
    const diagnosisPointer = uniqBy([
      ...orderLine[index]['Primary Diagnosis'] || [],
      ...orderLine[index].Diagnosis,
    ], uniqByKey).map((diagnosisItem) => {
      const diagnosisID = diagnosisItem.value ? diagnosisItem.value : diagnosisItem.ID;
      const diagnosisIndex = diagnosis.findIndex(item => item.ID === diagnosisID);
      return type === 'alphabetical' ? 'ABCDEFGHIJKL'.slice(diagnosisIndex, diagnosisIndex + 1) : diagnosisIndex + 1;
    }).join('');
    if (diagnosisPointer) {
      return diagnosisPointer;
    }
    return null;
  }
  return null;
};

export default getOrderLineDiagnosisPointer;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDiagnosisPointer.js